import { decryptUtf8, encryptUtf8 } from './aes.ts';

export type CiphertextPayload = {
  v: 1;
  alg: 'A256GCM';
  iv: string;
  ciphertext: string;
};

export function parseCiphertextPayload(text: string): CiphertextPayload | null {
  if (!text || text[0] !== '{') return null;
  try {
    const parsed = JSON.parse(text);
    if (
      parsed &&
      parsed.v === 1 &&
      parsed.alg === 'A256GCM' &&
      typeof parsed.iv === 'string' &&
      typeof parsed.ciphertext === 'string'
    ) {
      return parsed as CiphertextPayload;
    }
  } catch {
    return null;
  }
  return null;
}

export function isCiphertextPayload(text: string): boolean {
  return parseCiphertextPayload(text) !== null;
}

export async function encryptMessageText(threadKey: CryptoKey, plaintext: string): Promise<string> {
  const wrapped = await encryptUtf8(threadKey, plaintext);
  const payload: CiphertextPayload = {
    v: 1,
    alg: 'A256GCM',
    iv: wrapped.iv,
    ciphertext: wrapped.ciphertext
  };
  return JSON.stringify(payload);
}

export async function decryptMessageText(threadKey: CryptoKey, text: string): Promise<string> {
  const payload = parseCiphertextPayload(text);
  if (!payload) return text;
  return decryptUtf8(threadKey, payload.iv, payload.ciphertext);
}
